import { zustandStorage } from "@helpers/storage";
/* -----------------Globals--------------- */
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

/* -----------------Types--------------- */
type State = {
	shownStartDialogs?: { [key: string]: boolean };
	setStartDialogShown: (key: string) => void;
	resetStartDialogShown: () => void;
};

/* -----------------Store--------------- */
export const useStartDialogStore = create<State>()(
	persist(
		(set) => ({
			shownStartDialogs: undefined,
			setStartDialogShown: (key: string) =>
				set((state) => ({
					shownStartDialogs: {
						...state.shownStartDialogs,
						[key]: true,
					},
				})),
			resetStartDialogShown: () =>
				set({
					shownStartDialogs: undefined,
				}),
		}),
		{
			name: "startDialogStore",
			storage: createJSONStorage(() => zustandStorage),
		},
	),
);
